<template>
  <div class="Courses px-12">
    <div class="font-26"><b> (Mod 1) BodyTalk: Fundamentals - Part 2</b></div>
    <v-card flat color="#F9EFE4" class="pa-3 my-3">
      <v-icon color="#BC7410">mdi-information</v-icon>
      <span style="color: #a55c0f" class="ml-3"
        >This Course requires (Mod 2) BodyTalk: Fundamentals - Part 1</span
      >
    </v-card>
    <v-divider class="divider"></v-divider>
    <div class="my-5 d-flex justify-space-between">
      <div class="font-18"><b>Instructor</b></div>
      <!-- <div class="d-flex justify-end">
        <v-btn color="primary" to="/" class="px-3 py-3" depressed
          >Course Description</v-btn
        >
      </div> -->
    </div>

    <div class="mt-3 d-flex">
      <v-avatar size="90">
        <img v-if="
          GetSeminarById.Instructor?.ProfileImage != null" alt="Avatar"
          @error="setDefaultImage" 
          :src="concatBaseurl(GetSeminarById.Instructor?.ProfileImage)"
        />
        <img
          v-else
          alt="Avatar"
          src="https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png"
        />
      </v-avatar>
      <!-- :src="GetSeminarById.Instructor.ProfileImage"  -->
      <div class="ml-5">
        <div class="font-17 lightgrey">
          {{ GetSeminarById.Instructor?.FirstName }}
          {{ GetSeminarById.Instructor?.LastName }}
        </div>
        <div class="lightgrey">miranda@ibabodytalk.com</div>
        <div class="lightgrey">www.miranda.com</div>
      </div>
    </div>
    <v-divider class="divider"></v-divider>
    <div class="font-18"><b>Coordinator</b></div>
    <div class="lightgrey">
      {{ GetSeminarById.Coordinator?.FirstName }}
      {{ GetSeminarById.Coordinator?.LastName }}
    </div>
    <div class="lightgrey">irenekhor.mac@gmail.com</div>
    <div class="lightgrey">{{ GetSeminarById.Coordinator?.Phone }}</div>
    <v-divider class="divider"></v-divider>
    <div class="font-18"><b>Location</b></div>
    <div class="lightgrey" v-if="GetSeminarById.Type == 2">
      Online Live Stream
    </div>
    <div class="lightgrey">
      {{ GetSeminarById.Location?.City }}, {{ GetSeminarById.Location?.Country }}
    </div>
    <v-divider class="divider"></v-divider>
    <div class="font-18"><b>Discount Details </b></div>
    <div class="lightgrey">
      <!-- Early bird price of AUD850.00 to be paid in full by 10 August 2021
      Monitors- AUD250.00 Cancellation policy: - If the instructor should cancel
      the course a full refund applies. -When a student withdraws from the
      course before or on 20 August 75% refund applies. When the student
      withdraws on 21 August or later no refund applies. -->
      {{ GetSeminarById.DiscountNote }}
    </div>
    <div class="font-18"><b>Other Details </b></div>
    <div class="lightgrey">
      <!-- This Course will provide everything you need to prepare you for... [Note:
      this field comes from the "Other Info (optionly) " feild when an
      instructor (or IBA Admin) adds Seminar.] -->
      {{ GetSeminarById.OtherNote }}
    </div>
    <v-card class="my-6 px-8 py-5" flat color="#ECF1F2">
      <div class="font-18"><b>Waiver</b></div>
      <div class="lightgrey my-3">
        This instructor requiers you to read and accept waiver.
      </div>
      <div class="lightgrey">
        <b
          >If you choose to register for this course, yout are required to agree
          to the instutor’s waiver. here you can view the waiver. Once agreed,
          you will be able to register for this course.</b
        >
      </div>
      <v-checkbox v-if="GetSeminarById.WaiverOne">
        <template v-slot:label>
          <div class="lightgrey">
            I agree to the
            <span class="primary--text"
              ><b>
                <a
                  @click="openLink(GetSeminarById.WaiverOne)"
                  :href="GetSeminarById.WaiverOne"
                  target="_blank"
                  class="text-decoration-none"
                  >IBA Waiver (1)</a
                ></b
              ></span
            >
          </div>
        </template>
      </v-checkbox>
      <v-checkbox v-if="GetSeminarById.WaiverTwo">
        <template v-slot:label>
          <div class="lightgrey">
            I agree to the
            <span class="primary--text"
              ><b>
                <a
                  @click.prevent="openLink(GetSeminarById.WaiverTwo)"
                  :href="GetSeminarById.WaiverTwo"
                  target="_blank"
                  class="text-decoration-none"
                  >IBA Waiver (2)</a
                ></b
              ></span
            >
          </div>
        </template>
      </v-checkbox>
    </v-card>
    <v-divider></v-divider>
    <div
      v-for="(item, index) in GetSeminarById.SeminarDateAndTimes"
      :key="index"
    >
      <v-row class="d-flex align-center">
        <v-col cols="2">
          <div>
            <b>Day {{ index + 1 }}:</b>
          </div>
        </v-col>
        <v-col cols="10">
          <v-card
            flat
            class="px-5 py-2 ml-3 d-flex justify-space-between"
            color="#ECF1F2"
          >
            <div class="font-14">{{ getWeekday(item.Date) }}</div>
            <div class="font-14">{{ formatDate(item.Date) }}</div>
            <div class="font-14">
              {{ formatTime(item.StartTime) }} - {{ formatTime(item.EndTime) }}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="d-flex mt-8">
      <div><b> Price</b></div>
      <div class="ml-2">
        <b>$ {{ GetSeminarById.SeminarPayment?.FullPrice }}.000 USD</b>
      </div>
    </div>
    <div class="d-flex mt-1">
      <div><b> Early Bird Price</b></div>
      <div class="ml-2">
        <b
          >$ {{ GetSeminarById.SeminarPayment?.EarlyBirdPrice }} USD(end
          {{ GetSeminarById.SeminarPayment?.EarlyBirdEndTime?.split("T")[0] }})</b
        >
      </div>
    </div>
    <div class="d-flex mt-1" v-if="GetSeminarById.SeminarPayment?.MonitorRate">
      <div><b>Monitor Price</b></div>
      <div class="ml-2"><b>$ 175 USD</b></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "seeseminar",
  props: ["Id"],
  methods: {
    setDefaultImage(event) {
      event.target.src = 'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
    },
    concatBaseurl(url) {
      // return process.env.VUE_APP_IMG_URL + url;
      return url;
    },
    openLink(url) {
      const googleDriveUrl = process.env.VUE_APP_IMG_URL + url;
      window.open(googleDriveUrl, "_blank");
    },
    getWeekday(dateString) {
      const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return daysOfWeek[moment.utc(dateString).local().day()];
    },
    formatDate(dateTimeString) {
      return moment.utc(dateTimeString).local().format("MMM D, YYYY");
    },
    formatTime(dateTimeString) {
      return moment.utc(dateTimeString).local().format("h:mm A");
    },
  },
  mounted() {
    const obj = {
      Id: this.Id,
    };
    this.$store.dispatch("GetSeminarById", obj);
  },
  computed: {
    ...mapGetters(["GetSeminarById"]),
  },
};
</script>

<style></style>
